import { APP_DATE_FORMATS, AppDateAdapter } from '@app/shared/date.adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { SWIPER_CONFIG, SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';

import { CarouselCardsSharedComponent } from '@app/components/carousel-cards-shared/carousel-cards-shared.component';
import { CoveragesSectionComponent } from '@app/components/coverages-section/coverages-section.component';
import { DatePipe } from '@angular/common';
import { DateWithLocalePipe } from '@app/pipes/date-with-locale.pipe';
import { FilterObjPipe } from '@app/pipes/filter-obj.pipe';
import { HomeIconComponent } from '@app/modules/home/components/home-icon/home-icon.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatErrorMessageComponent } from '@app/errors/mat-error-message.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { ModalBuzonComponent } from '@app/components/modal-buzon/modal-buzon.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgModule } from '@angular/core';
import { ProgressHeaderComponent } from '@app/components/progress-header/progress-header.component';
import { ReasonsSectionComponent } from '@app/components/reasons-section/reasons-section.component';
import { RowFormatPipe } from '@app/pipes/row-format.pipe';
import { SharedModule } from './shared.module';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: "horizontal",
  slidesPerView: "auto",
};
@NgModule({
  declarations: [
    CoveragesSectionComponent,
    HomeIconComponent,
    RowFormatPipe,
    DateWithLocalePipe,
    FilterObjPipe,
    ModalBuzonComponent,
    MatErrorMessageComponent,
    ProgressHeaderComponent,
    CarouselCardsSharedComponent,
    ReasonsSectionComponent
 ],
  imports: [
    SharedModule,
    MatIconModule,
    MatButtonModule,
    SwiperModule,
    MatFormFieldModule,
    NgCircleProgressModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 25,
      outerStrokeWidth: 2,
      innerStrokeWidth: 12,
      outerStrokeColor: "#53bad1",
      innerStrokeColor: "#C7E596",
      showInnerStroke: false,
      animationDuration: 300,
    }),
  ],
  exports: [
    CoveragesSectionComponent,
    HomeIconComponent,
    RowFormatPipe,
    DateWithLocalePipe,
    FilterObjPipe,
    ModalBuzonComponent,
    MatErrorMessageComponent,
    ProgressHeaderComponent,
    CarouselCardsSharedComponent,
    ReasonsSectionComponent
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    }
  ]
})
export class LegacyModule { }
